import { AVAILABILITY_WS_EVENTS } from './constants';

type AvailabilitySocketEventName = (typeof AVAILABILITY_WS_EVENTS)[keyof typeof AVAILABILITY_WS_EVENTS];

type AvailabilitySocketEventHandler<TPayload> = (payload: TPayload) => void;

const availabilitySocketEventsTarget = new EventTarget();

export const emitAvailabilitySocketEvent = <TPayload>(eventName: AvailabilitySocketEventName, payload: TPayload) => {
  availabilitySocketEventsTarget.dispatchEvent(new CustomEvent(eventName, { detail: payload }));
};

export const subscribeAvailabilitySocketEvent = <TPayload>(
  eventName: AvailabilitySocketEventName,
  handler: AvailabilitySocketEventHandler<TPayload>,
) => {
  const listener = (event: Event) => {
    handler((event as CustomEvent<TPayload>).detail);
  };

  availabilitySocketEventsTarget.addEventListener(eventName, listener);

  return () => {
    availabilitySocketEventsTarget.removeEventListener(eventName, listener);
  };
};
